<template>
  <TheHeader />
  <div class="more">
    <div v-if="error">
      {{ error }}
    </div>
    <div v-else>
      <div v-if="project">
        <h3 class="title">{{ project.name }}</h3>
        <Slider :imgs="project.img" />
      </div>
      <div v-else>Loading...</div>
    </div>
  </div>
  <TheFooter />
</template>

<script>
import getProject from '@/hooks/getProject.js';
import Slider from '@/components/Slider.vue';
import TheFooter from '@/components/TheFooter.vue';
import TheHeader from '@/components/TheHeader.vue';
export default {
  components: {
    Slider,
    TheFooter,
    TheHeader,
  },
  props: ['id'],
  setup(props) {
    const { project, error, load } = getProject(props.id);
    load();

    return { project, error, load };
  },
};
</script>

<style lang="scss">
.more {
  margin: 5%;

  border-image: url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="UTF-8" ?><svg version="1.1" width="5" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M2 1 h1 v1 h-1 z M1 2 h1 v1 h-1 z M3 2 h1 v1 h-1 z M2 3 h1 v1 h-1 z" fill="rgb(33,37,41)" /></svg>');
  border-image-repeat: space;
  border-image-slice: 2;
  border-image-width: 2;
  border-image-outset: 2;
  border-style: solid;
  border-width: 4px;
  box-shadow: 4px 8px black, 0 0 black, 8px 4px black, 0 0 black;

  & .title {
    display: table;
    padding: 0 1rem;
    margin: -1.8rem 5rem 1rem;
    font-size: 1.5rem;
    background-color: #fff;
    text-transform: uppercase;
  }
}
</style>
